<template>
  <div class="bottom-banner" :class="[options.className, { closed }]">
    <div :class="options.className === 'upgrade-offer' ? 'container-wide' : 'container'">
      <div v-if="options.blackfriday2022" class="bf-heading">
        <BlackFridayFonts class="font" :words="['72%', 'OFF!']" />
        <div>
          <p class="black-friday">
            BLACK FRIDAY
          </p>
          <p class="limited-time-offer">
            LIMITED-TIME OFFER
          </p>
        </div>
      </div>
      <div v-else-if="options.financeCourses" class="fc-heading">
        <GlitchFont
          text="72% OFF!"
          text-size="58"
          class="fc-fonts"
        />
        <div>
          <p class="finance-courses">
            ALL FINANCE COURSES
          </p>
          <p class="limited-time-offer">
            LIMITED-TIME OFFER
          </p>
        </div>
      </div>
      <div v-else class="heading">
        <div v-if="options.campaignTitle" class="campaign-title" v-html="options.campaignTitle" />
        <p v-if="options.highlight" class="highlight" :title="options.highlight">
          {{ options.highlight }}
        </p>
        <div v-if="options.labelText" class="label-accent">
          {{ options.labelText }}
        </div>
        <span v-if="options.title"> {{ options.title }} </span>
      </div>
      <slot name="countdown" />
      <button
        class="btn-primary btn-lg" :class="options.subscribeClass"
        @click="$emit('subscribe', options.promoPlanType)"
      >
        {{ options.campaign === 'one-of-two-hundred' ? `Grab ${discount}% OFF` : options.buttonText }}
      </button>
    </div>
    <CloseIcon class="icon-close" @click="$emit('close')" />
  </div>
</template>

<script>
import CloseIcon from '@itbpbg/lms-components/src/assets/svg/close-icon.svg?vue-component';
import BlackFridayFonts from '@itbpbg/lms-components/src/components/BlackFridayFonts';
import GlitchFont from '@itbpbg/lms-components/src/components/GlitchFont';

export default {
  components: {
    BlackFridayFonts,
    GlitchFont,
    CloseIcon,
  },
  props: {
    discount: { type: Number, default: 0, required: false },
    options: { type: Object, default: () => ({}), required: true },
    closed: { type: Boolean, required: false },
  },
};
</script>

<style lang="scss" scoped>
.bottom-banner {
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9;
  bottom: -120px;
  transition: ease all var(--duration);
  color: var(--main-light);
  height: 120px;
  display: flex;
  align-items: center;
  padding: var(--spacing-24);

  .container,
  .container-wide {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &.fixed {
    bottom: 0;
    transition: ease all var(--duration);
  }

  &.closed {
    bottom: -120px;
  }

  .icon-close {
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;

    path[fill] {
      fill: var(--main-light-shade-4);
    }
  }

  .heading {
    .highlight,
    .campaign-title {
      font-size: 40px;
      letter-spacing: 0.015em;
      margin: 0;
      position: relative;
    }

    .highlight:after {
      content: attr(title);
      position: absolute;
      top: -2px;
      left: -2.5px;
      right: 0;
      mix-blend-mode: color-dodge;
    }

    .label-accent {
      font-size: 17px;
      padding: 6px 7px;
      max-width: 180px;
      margin-bottom: 7px;
    }

    span {
      font-size: 21px;
      color: var(--main-light-shade-3);
    }
  }

  .bf-heading {
    display: flex;
    align-items: center;
    margin-right: auto;
    width: 100%;

    p {
      line-height: 110%;
      font-weight: 800;
      margin: 0;
    }

    .black-friday {
      font-size: 30px;
      color: var(--extreme-yellow);
    }

    .limited-time-offer {
      font-size: 21px;
      color: var(--extreme-fucsia);
    }

    ::v-deep .holder-groups {
      justify-content: flex-start;
      margin-right: 10px;

      .groups {
        width: 125px;
      }
    }
  }

  .fc-heading {
    position: relative;
    display: flex;
    align-items: center;
    margin-right: auto;
    width: 100%;

    p {
      line-height: 110%;
      font-weight: 800;
      margin: 0;
    }

    .finance-courses {
      font-weight: 900;
      font-size: 28px;
      line-height: 33px;
      color: #19F5EE;
      text-shadow: 0 1.3644px 3.31353px rgba(37, 244, 238, 0.5), 0.974569px 3.11862px 5.45759px #2D0CEC;
    }

    .limited-time-offer {
      font-size: 22px;
      color: #FC1E96;
    }

    ::v-deep .holder-groups {
      justify-content: flex-start;
      margin-right: var(--spacing-16);

      .groups {
        width: 134px;
      }
    }
  }

  .btn-primary {
    width: 100%;
    max-width: 300px;
  }

  @include bp($bp-mobile) {
    display: none;
  }
}
</style>
